import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TutorSchedule } from "../../firestore/Types/TutorProfileSchema";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";

export function CalendarDaysOfWeekSimpleAvailabilty( { Schedule } : { Schedule: TutorSchedule }) {
    //CALENDAR ICON
    const unabailableStyle = "rounded-lg border-solid border-2 text-center bg-gray-300 text-gray-400 border-gray-300 text-xs  ml-1 md:w-8 md:h-6 max-md:w-1 max-md:h-1 max-md:mt-2 max-md:text-white leading-[20px]";
    const availableStyle = "rounded-lg border-solid border-2 w-8 h-6 text-center bg-green-300 text-green-600 border-green-400 text-xs ml-1 leading-[20px]";
    return (
        <>
            <div className="mx-2">
                <FontAwesomeIcon icon={faCalendarDays} color="#4b5563" width="20px" title="Availabilities" />
            </div>
          
            <div className={Schedule.Monday === 0 ? unabailableStyle : availableStyle}>Mo</div>
            <div className={Schedule.Tuesday === 0 ? unabailableStyle : availableStyle}>Tu</div>
            <div className={Schedule.Wednesday === 0 ? unabailableStyle : availableStyle}>We</div>
            <div className={Schedule.Thursday === 0 ? unabailableStyle : availableStyle}>Th</div>
            <div className={Schedule.Friday === 0 ? unabailableStyle : availableStyle}>Fr</div>
            <div className={Schedule.Saturday === 0 ? unabailableStyle : availableStyle}>Sa</div>
            <div className={Schedule.Sunday === 0 ? unabailableStyle : availableStyle}>Su</div>
        </>
    );
}